import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import CheckBox from '../../Components/CheckBox/CheckBox'
import { FaPlusSquare } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { MdDeleteOutline, MdOutlineSaveAlt } from 'react-icons/md'
import http from '../../Service/http'
import { toast } from 'react-toastify'
import { accept, } from '../../store/accept'
import SearchRole from '../../block/ReactSearchRole'
import { getNameHeadTeacher, getOknoTeacherRole } from '../../Service/accept'
import ConfirmModal from './../../Components/Modal/ConfirmModal'
import { FcCancel } from 'react-icons/fc'
import { auth } from '../../store/auth'

export const AcceptCustomer = observer(function () {
	interface FormType {
		id_AVN_User: number;
		id_okno_role_teacher: number;
		t_fio: string;
		
		// Add other properties as needed
	  }
	const { t } = useTranslation()
	const notify = (title: string) => toast.success(title)
	const [idTeacher, setIdTeacher] = useState<number>(0)
	const [addNew, setAddNew] = useState<boolean>(false)
	const [form, setForm] = useState<FormType>({
		id_AVN_User: auth.user.data.id,
		id_okno_role_teacher: 1,
		t_fio: '',
		// Add any other properties if needed
	  });
	  const [formType, setFormType] = useState([]);
	const [headNameList,setHeadNameList]=useState([])

	const [delModal, setDelModal] = useState<{
		modal: boolean
		id_docs: number
		name: string
	}>({
		modal: false,
		id_docs: 0,
		name: ''
	})

	const [disbles, setDsbles] = useState<number>(0)

	const getAllTeachers = async () => {
		const data = await getOknoTeacherRole()
		accept.newOknoTeachers(data)
	}

	const getAllTeacherPole= async () => {
		const data = await getNameHeadTeacher()
		console.log('teachge',data)
		setHeadNameList(data)
	} 
	useEffect(() => {
		getAllTeacherPole()
		getAllTeachers()
	}, [])

	const tdCenter = { display: 'flex', justifyContent: 'center', width: '100%' }
	const result = accept.oknoRoleTeacher?.map((item: any) => {
		const mappedItem: { [key: string]: boolean } = {};
	  
		headNameList.forEach((obj: any) => {
			const name = obj.name;
			const value = item[obj.pole];
			mappedItem[name] = value === true ? true : false;
		});
	  
		return mappedItem;
	});

	return (
		<>
			<ConfirmModal
				setIsOpen={() => {
					setDelModal({
						modal: false,
						id_docs: 0,
						name: ''
					})
				}}
				title={delModal.name}
				isOpen={delModal.modal}
				hundleTrue={async () => {
					if (delModal.id_docs) {
						const res = await http.delete('/okno/customer?id=' + delModal.id_docs)
						if (res.data.result) {
							getAllTeachers()
							notify(t('st:other.saved'))
							setDelModal({
								modal: false,
								id_docs: 0,
								name: ''
							})
						} else {
							notify(t('st:other.reject'))
						}
					}
				}}
			/>
			<div className='TableWrapper'>
				<table className='accept_table'>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							{headNameList?.length && headNameList?.map((pole:any)=><th style={{ width: '5%' }}>{pole.okno_title}</th>
							)}
							<th style={{ width: '5%' }}>
								<FaPlusSquare
									style={{ fontSize: 18 }}
									onClick={() => {
										setAddNew(!addNew)
										setDsbles(0)
									}}
								/>
							</th>
						</tr>
					</thead>
					<tbody>
						{addNew ? (
							<tr style={{ backgroundColor: 'rgb(160 202 223)', height: '52' }}>
								<td>{0}</td>
								<td style={{ textAlign: 'left' }}>
									<SearchRole
										style={{ borderRadius: '6px' }}
										changeIdStud={(param: number) => {
											setIdTeacher(param)
										}}
									/>
								</td>
								{headNameList.map((obj:any, colIndex) => (
                <td>
				  <CheckBox
   					 onchange={(e: any) => {   					     
					setFormType((state: any) => {
						console.log('checked',{[obj.okno_pole] : e})
						console.log('form',formType)
   					         return { ...state, [obj.okno_pole] : e };
   					     });
   					 }}
   					 styles={tdCenter}
					//  checked={formType && formType[obj.okno_pole]===true ? true :false}
					checked={Boolean(formType && formType[obj.okno_pole])}
					
				     active={true}
   					 dsbl={false}
   					 item={formType}
/>

            </td>
		   ))
				}
								 
							
								<td>
									<div className='edit'>
										{
											<MdOutlineSaveAlt
												title={t('st:button.save')}
												onClick={async () => {
													const res = await http.post('/okno/customer', {
														
														...formType,
														id_okno_role_teacher: idTeacher,
														id_AVN_User:form.id_AVN_User,
                                                        t_fio:form.t_fio
													})
													if (res.data.result) {
														getAllTeachers()
														notify(t('st:other.saved'))
														setAddNew(!addNew)
														setDsbles(0)
													} else {
														notify(t('st:other.reject'))
													}
												}}
											/>
										}
									</div>
								</td>
							</tr>
						) : (
							''
						)}

						{accept.oknoRoleTeacher.map((item: any, index: number) => {
							let dsbl = true
							if (disbles === item.id_okno_role_teacher) {
								return (
									<tr key={index} style={{ backgroundColor: 'rgb(160 202 223)', height: dsbl ? '' : '52' }}>
										<td>{index + 1}</td>
										<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
		{headNameList.map((obj:any, colIndex) => (
                <td>
				  <CheckBox
   					 onchange={(e: any) => {   					     
					setFormType((state: any) => {
						console.log('checked',{[obj.okno_pole] : e})
						console.log('form',formType)
   					         return { ...state, [obj.okno_pole] : e };
   					     });
   					 }}
   					 styles={tdCenter}
					//  checked={formType && formType[obj.okno_pole]===true ? true :false}
					checked={Boolean(formType && formType[obj.okno_pole])}
				     active={true}
   					 dsbl={false}
   					 item={item}
/>

            </td>
		   ))
				}
										<td>
											<div className='edit'>
												{
													<MdOutlineSaveAlt
														title='Сохранить'
														onClick={async () => {
															const data={form,formType}
															const res = await http.put('/okno/customer', {...formType,
																id_okno_role_teacher: form.id_okno_role_teacher,
																id_AVN_User:form.id_AVN_User,
																t_fio:form.t_fio})
															if (res.data.result) {
																getAllTeachers()
																notify(t('st:other.saved'))
															} else {
																notify(t('st:other.reject'))
															}
															setDsbles(0)
														}}
													/>
												}
												<FcCancel
													onClick={() => {
														setDsbles(0)
													}}
												/>
											</div>
										</td>
									</tr>
								)
							}
							return (
								<tr
									key={index}
									style={{ backgroundColor: dsbl ? '' : 'rgb(160 202 223)', height: dsbl ? '' : '52' }}
									onClick={() => {
										setDsbles(0)
										setAddNew(false)
									}}
								>
									<td>{index + 1}</td>
									<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
									{ headNameList.map((obj:any, colIndex) => (
										<td>
					
											<CheckBox
												onchange={() => {}}
												styles={tdCenter}
												checked={item[obj.okno_pole]}
												active={true}
												dsbl={dsbl}
												item={item}
											/>

										</td>
									))}
									<td>
										<div className='edit'>
											{
												<FiEdit
													onClick={(e: any) => {
														e.stopPropagation()
														setDsbles(item.id_okno_role_teacher)
														setForm(item)
														setFormType(item)

														setAddNew(false)
													}}
												/>
											}
											<MdDeleteOutline
												style={{ zIndex: 1222 }}
												onClick={() => {
													setDelModal({
														modal: true,
														id_docs: item.id_okno_role_teacher,
														name: item.t_fio
													})
												}}
											/>
										</div>
									</td>
								</tr>
							)
						})}
						{/* {
                makeCheckboxes().map(item => {
                    return <td>
                        {
                            item
                        }
                    </td>
                })
            } */}
					</tbody>
				</table>
			</div>
		</>
	)
})
